import React, { useEffect } from "react";
import { Dialog, DialogContent, Typography } from "@mui/material";

const SuccessPopup = ({ onClose }) => {
	useEffect(() => {
		const timer = setTimeout(() => {
			onClose(); // Close the success popup after 2 seconds
		}, 2000);

		return () => clearTimeout(timer);
	}, [onClose]);

	return (
		<Dialog open={true} onClose={onClose}>
			<DialogContent>
				<Typography>Data submitted successfully</Typography>
			</DialogContent>
		</Dialog>
	);
};

export default SuccessPopup;
